import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  tabWrapper: {
    color: theme.palette.secondary.main,
    width: '100%',

    '& .MuiTabs-flexContainer': {
      justifyContent: 'center',
    },

    '& .MuiTabs-indicator': {
      height: 2,
      background: theme.palette.secondary.main,
    },
    '& .MuiTab-root': {},
  },

  tab: {
    fontSize: 12,
    textTransform: 'none',
    borderTopRightRadius: theme.spacing(0.5),
    borderTopLeftRadius: theme.spacing(0.5),
    margin: theme.spacing(0, 0.5),
  },
  selectedTab: {
    fontWeight: theme.typography.fontWeightBold,
  },
  unselectedTab: {
    color: theme.palette.text.disabled,
  },

  tabPanel: {
    height: 'calc(100% - 48px)',
  },
}))
